/**
 * The min number of characters allowed for username
 */
export const MIN_USERNAME_LENGTH = 4;

/**
 * The min number of characters allowed for username
 */
export const MAX_USERNAME_LENGTH = 20;

/**
 * The max number of characters allowed for user last name
 */
export const MAX_LAST_NAME_LENGTH = 20;

/**
 * The max number of characters allowed for user first name
 */
export const MAX_FIRST_NAME_LENGTH = 150;

/**
 * Excldue % from user field inputs
 */
export const USER_FIELD_BLACKLIST_CHARS = [
  '%', 
  '<',
  '>',
  '&',
  '"'
];
